import React, { useState, useEffect, useCallback } from 'react';
import { FaPen, FaRegCalendar, FaRegCalendarCheck, FaSearch, FaTrash, FaSave, FaFilePdf } from 'react-icons/fa';
import { Button, ButtonGroup, Dropdown, Form, InputGroup } from 'react-bootstrap';

import PageContainer from '../../../components/PageContainer';
import ListLayout from '../../../components/ListLayout';
import { columns } from './MargemListInfo';
import Loading from '../../../components/Loading';
import CustomModal from '../../../components/CustomModal';
import useAlertNotification from "../../../context/AlertNotificationContext";

import MargemDetail from './MargemDetail';

import ErrorRequestService from '../../../services/errorRequest';
import ProjetosApiService from '../../../services/api/ProjetosApiService';
import UtilService from '../../../services/util';

import useAuth from '../../../context/AuthContext';
import { MargemListHelpModal } from './MargemListHelpModal';
import { useRouteMatch, useHistory } from 'react-router-dom';

import { BsThreeDotsVertical, BsFillPencilFill, BsFillTrash3Fill, BsEye, BsPlusLg } from "react-icons/bs";
import { MdClose } from 'react-icons/md';

import { useCheckboxState, Checkbox } from "reakit/Checkbox";
import ConvertDataService from '../../../services/util/ConvertDatas';

const INITIAL_PAGEPARAMS = {
    orderBy: 'cod',
    orderDir: 'asc'
};

const ORDER_DIR_NUM = { asc: 1, desc: -1 };

function MargemList() {
    const { user } = useAuth();
    const match = useRouteMatch();
    const history = useHistory();
    const alert = useAlertNotification();

    // STATE
    const [rowsData, setRowsData] = useState(null);
    const [filteredData, setFilteredData] = useState(null);
    const [orderBy, setOrderBy] = useState(INITIAL_PAGEPARAMS.orderBy);
    const [orderDir, setOrderDir] = useState(INITIAL_PAGEPARAMS.orderDir);
    const [isLoading, setIsLoading] = useState(true);
    const [rowsDataChecked, setRowsDataChecked] = useState([]);
    const [allReportsChecked, setAllReportsChecked] = useState(false);
    const [verificarRow, setVerificarRow] = useState(false);

    const checkbox = useCheckboxState({ state: [] });

    // FUNCTIONS
    /** Define o clique sobre um registro da lista */
    const rowClick = (e, item) => {
        const auxDadosLinha = e.target.parentElement.className
        const auxDadosLinhaParent = e.target.parentElement.parentElement.className;

        const excludeClasses = [
            "d-flex container-botoes-opcoes",
            "icone-menu"
          ];
        
        if(!excludeClasses.includes(auxDadosLinhaParent) && !excludeClasses.includes(auxDadosLinha)) {
            
            CustomModal.show({
                title: item.nome,
                body: (
                    <MargemDetail
                        onCancel={() => CustomModal.hide()}
                        onSave={() => CustomModal.hide()}
                        props={item}
                    />
                )
            })
        }
    }

    const checkDataChecked = (arrCheck) => {
        if (!arrCheck || arrCheck.length === 0 || !rowsDataChecked || rowsDataChecked.length === 0) {
            setAllReportsChecked(false);
            return;
        }
    
        const dataIncludesDataChecked = arrCheck.every(item =>
            rowsDataChecked.some(selected => selected.id === item.id)
        );
    
        setAllReportsChecked(dataIncludesDataChecked);
    };

    const notDuplicate = (arr) => arr.reduce((accum, curr) => {
        if (accum.length <= 0) return [curr];

        const notSame = accum.filter(item => item.id !== curr.id);
        return [...notSame, curr];
    }, []);

    const selectAllReports = () => {
        setAllReportsChecked(!allReportsChecked)
        const auxFilteredData = verificarRow ? rowsData : filteredData;
        
        const newDataChecked = notDuplicate([...rowsDataChecked, ...auxFilteredData])

        if (!allReportsChecked) {
            checkbox.setState(newDataChecked)
            setRowsDataChecked(newDataChecked)
        } else {
            const newArr = newDataChecked.filter(item => 
                !auxFilteredData.some(aux => aux.id === item.id)
            );
            setRowsDataChecked(newArr)
            checkbox.setState(newArr)
        }
    }

    const modalDeleteMargin = (item) => {
        let reportsNames = item.length > 1 ? item.map(item => item.nome) : item[0].nome;
        let reportsIds = item.length > 1 ? item.map(item => item.id).join(',') : `${item[0].id}`;
            CustomModal.show({
                body: `Tem certeza que deseja excluir ${item.length > 1 ? item.length + ' relatórios' : 'esse relatório'}?`,
                footer: (
                <>
                    <div className="w-100 d-flex flex-column">
                        {
                            item.length > 1 ?
                            reportsNames.map((item, index) => <p className="text-danger ml-4 mb-1" key={index}>{item}</p>) 
                        :
                        <p className="text-danger">{item[0].nome}</p>
                        }
                    </div>
                    <>
                        <Button className="mr-2" variant="outline-success" onClick={() => deleteMargin(reportsIds)}>Sim</Button>
                        <Button variant="outline-danger" onClick={() => CustomModal.hide()}>Cancelar</Button>
                    </>
                </>
                )
            })
    }

    const deleteMargin = async (reportsIds) => {
        const { email } = user;
    
        setIsLoading(true);
    
        try {
            const resp = (await ProjetosApiService.deleteMargens(email, {
                id: reportsIds,
                ativo: false
            }));
    
            const idsToRemove = reportsIds.split(',').map(id => parseInt(id));
            const newChecked = rowsDataChecked.filter(item => !idsToRemove.includes(item.id));
            setRowsDataChecked(newChecked);
    
            await getDataList();
    
            CustomModal.hide();
            alert.success(resp.data.message);
    
        } catch (err) {
            const errorService = new ErrorRequestService(err);
            const errorMsg = errorService.getErrors();
            console.log(errorMsg);
            alert.error(errorMsg);
        } finally {
            setIsLoading(false);
        }
    };

    /** Adiciona click e atributos ao header */
    const getListHeader = () => {
        const headers = [];
        const defineOrder = (item) => {
            if (orderBy === item) {
                const newDir = (orderDir === 'asc') ? 'desc' : 'asc';
                setOrderDir(newDir);
                return;
            }
            setOrderBy(item);
        }
        columns.forEach(item => {
            const waySign = (ORDER_DIR_NUM[orderDir] > 0) ? '▴' : '▾';
            const orderInd = (orderBy === item.name)
                ? { ordered: `${waySign}` }
                : {};
            let head = {
                ...item,
                ...orderInd,
                onClick: () => defineOrder(item.name),
            }
            if (item.name === 'checkbox') {
                head = {
                    ...item,
                    ...orderInd,
                    label: <Checkbox checked={allReportsChecked} />,
                    onClick: (e) => selectAllReports(),
                }
            }
            headers.push(head);
        })
        return headers;
    }

    const BodyAlterName = ({item}) => {
        const [alterName, setAlterName] = useState(item.nome);
        const [errors, setErrors] = useState({});

        const postAlterName = async (obj) => {
            const relatorioExistente = await ProjetosApiService.getNameMargem(alterName.trim());
    
            if (relatorioExistente.data.found) {
                setErrors({ alterName: "Já existe um relatório com este nome." });
                document.getElementById("alterName").focus();
                return;
            }
            try {
                const resp = await ProjetosApiService.updateNameMargem(obj.id, {"nome": alterName});
                CustomModal.hide();
                getDataList();
            } catch (error) {
                console.error("Não foi possível atualizar o nome do relatório", error);
                alert.error("Não foi possível alterar o nome do relatório.")
            }
        }

        return (
            <>
                <Form.Group>
                    <Form.Control
                        placeholder="Digite o novo nome do relatório..."
                        aria-label="Nome"
                        id="alterName"
                        name='alterName'
                        type='text'
                        value={alterName}
                        onChange={(e) => {
                            const { value } = e.target;
                            setAlterName(value);
                            setErrors({});
                        }}
                        isInvalid= {!!errors.alterName}
                    />
                    <Form.Control.Feedback type="invalid">
                        { errors.alterName }
                    </Form.Control.Feedback>
                </Form.Group>

                <div className='mt-3 d-flex justify-content-end'>
                    <Button variant="outline-info" onClick={() => postAlterName(item)}>
                        <FaSave /> Salvar
                    </Button>
                    <Button variant="outline-danger" onClick={() => CustomModal.hide()}>
                        <MdClose /> Cancelar
                    </Button>
                </div>

            </>
        )
    }

    const FuncionalidadesButtons = ({ item }) => {

        const redirectToCompleteView = (item) => {
            history.push(`${match.url}/${item.id}`);
        }

        const alterTitle = (item) => {

            CustomModal.show({
                title: "Deseja alterar o nome do relatório ?",
                body: < BodyAlterName item={item}/>,
            })
        }

        return (
            <div className="d-flex container-botoes-opcoes">
                <BsEye className="icone-menu" style={{ fill: "#17a2b8", marginRight:"16px" }} onClick={() => redirectToCompleteView(item)}/>
                <BsFillPencilFill className="icone-menu" style={{ fill: "#28a745", marginRight:"16px" }} onClick={() => alterTitle(item)} />
            </div>
        )
    }

    const dataChecked = (item) => {
        const exists = rowsDataChecked.some(data => data.id === item.id);
        if (!exists) {
            setRowsDataChecked([...rowsDataChecked, item]);
        }
    }

    useEffect(() => {setRowsDataChecked(rowsDataChecked.filter(data => checkbox.state.some(item => data.id == item.id)))}, [checkbox.state])

    /** Adequa os dados ao formato para lista */
    const defineDataList = () => {
        const sortRows = (a, b) => {
            let valA = a[orderBy];
            let valB = b[orderBy];
        
            if (orderBy === 'periodo_inicial' || orderBy === 'periodo_fim') {
                valA = new Date(valA);
                valB = new Date(valB);
            }
        
            if (valA < valB) return -1 * ORDER_DIR_NUM[orderDir];
            if (valA > valB) return 1 * ORDER_DIR_NUM[orderDir];
            return 0;
        };
        const dataList = [];
        const rows = filteredData || [];
        rows.sort(sortRows)
            .forEach(item => {
                const row = {
                    onClick: (e) => rowClick(e, item),
                    data: columns.map(col => {
                        if (col.name === 'checkbox') {
                            return {
                                value: <Checkbox {...checkbox} value={item}  onClick={(e) => {
                                    e.stopPropagation();
                                    const checked = e.target.getAttribute('aria-checked');
                                    if (checked === "false") dataChecked(item);
                                    else setRowsDataChecked(rowsDataChecked.filter(data => data !== item));
                                }} />
                            }
                        }
                        // ---------------- cor/icone bloqueio ----------------
                        if (col.name === 'bloqueio') {
                            return {
                                value: (item[col.name] ? <FaRegCalendarCheck /> : <FaRegCalendar />),
                                className: col.dynamicClass && col.dynamicClass(item[col.name]),
                                attr: {
                                    title: `${item[col.name] ? '' : 'Não '}Bloqueado`,
                                    'data-toggle': 'tooltip',
                                }
                            }
                        }
                        // ---------------- formato date dd/mm/yyyy ----------------
                        if (['dataInicio', 'dataFim', 'data_hora_criacao'].includes(col.name)) {
                            return {
                                value: ConvertDataService.convertDataToDDmmExtenseYYYY(item[col.name], true),
                                className: col.className
                            }
                        }
                        item["menu_opcoes"] = <FuncionalidadesButtons item={item}/>;
                        return {
                            value: item[col.name],
                            className: col.className
                        }
                    })
                }
                dataList.push(row);
            });
        return dataList;
    }

    /* Filtra a lista de dados */
    const filterList = (params) => {
        const { column, filter } = params;

        if (!column || !filter) {
            setFilteredData(rowsData);
            return
        }

        if(column == 'checkbox'){
            const filtered = rowsDataChecked.filter(item => item !== null);
            setAllReportsChecked(true);
            return setFilteredData(filtered);
        }

        if(column == 'data_hora_criacao'){
            const filtered = rowsData.filter(item => {
                const onlyDate = ConvertDataService.convertDataToDDmmExtenseYYYY(item[column], false).toLocaleLowerCase();
                return onlyDate.includes(filter.toLocaleLowerCase());
            });
            setFilteredData(filtered);
            return
        }

        const filtered = rowsData.filter(item => {
            const lwData = String(item[column]).toLowerCase();
            const lwFilter = String(filter).toLowerCase();

            return lwData.includes(lwFilter);
        });
        setFilteredData(filtered);
    }

    /** Traz as funcoes cadastradas no database  */
    const getDataList = useCallback(async () => {
        const { email } = user;

        setIsLoading(true);

        try {
            const resp = (await ProjetosApiService.getAll(email)).data;
            setRowsData(resp.data);
            setFilteredData(resp.data);
            checkDataChecked(resp.data);

        } catch (err) {
            const errorService = new ErrorRequestService(err);
            const errorMsg = errorService.getErrors();

            console.log(errorMsg);

            alert.error(errorMsg);

        } finally {
            setIsLoading(false);
        }
    }, []);


    const generatePDF = async (item) => {
        const { email } = user;
        setIsLoading(true);

        try {
            // Chamar backend para gerar PDF
            const response = await ProjetosApiService.generateMargemPdf(email, item[0].id);
            
            // Criar blob e fazer download
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${item[0].nome.replace(/[^a-z0-9]/gi, "_")}.pdf`;
            document.body.appendChild(link);
            link.click();
            
            // Limpar
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            alert.success("PDF gerado com sucesso!");

        } catch (err) {
            console.error("Erro ao gerar PDF:", err);
            alert.error("Erro ao gerar PDF");
        } finally {
            setIsLoading(false);
        }
    };

    // EFFECTS
    useEffect(() => {
        if (!rowsData) getDataList();
    }, [rowsData, getDataList]);

    const pageActions = [
        {
            label: 'Gerar PDF',
            color: 'primary',
            icon: <FaFilePdf />,
            onClick: () => generatePDF(rowsDataChecked),
            disabled: rowsDataChecked.length !== 1
        },
        {   
            label: `Excluir Relatório${rowsDataChecked.length > 1 ? 's' : ''}`,
            color: 'danger',
            icon: <BsFillTrash3Fill />,
            onClick: () => modalDeleteMargin(rowsDataChecked),
            disabled: rowsDataChecked.length === 0
        }
    ];

    const title = 'Relatórios';

    return (
        <PageContainer
            title={title}
            actions={pageActions}
            infoButton={<MargemListHelpModal />}
        >
            {isLoading
                ? <Loading message="Carregando..." />
                :
                <div id="tabela-meus-relatorios-de-margem">
                    <ListLayout
                        columns={getListHeader()}
                        rows={defineDataList()}
                        onSubmitFilter={filterList}
                        columnsNotFilter={['checkbox']}
                        //rowsDataChecked={rowsDataChecked}
                        //setRowsDataChecked={setRowsDataChecked}
                    />
                </div>
            }
            <CustomModal />
        </PageContainer>
    )
}

export default MargemList;
